/**
 * @generated SignedSource<<2f8df1005650e3306263c3666d6e0c79>>
 * @relayHash a36ca0edc536ede13ce4258ac391b607
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b75d4c24ffa334a2fa8ade5cd79af2b941370d14f5ea169012585b8a174753d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_prefetchSingleSelectFieldOptionsQuery$variables = {
  first?: number | null | undefined;
  id: string;
};
export type ui_prefetchSingleSelectFieldOptionsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment">;
};
export type ui_prefetchSingleSelectFieldOptionsQuery = {
  response: ui_prefetchSingleSelectFieldOptionsQuery$data;
  variables: ui_prefetchSingleSelectFieldOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = [
  (v2/*: any*/),
  {
    "kind": "Literal",
    "name": "searchBy",
    "value": ""
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_prefetchSingleSelectFieldOptionsQuery",
    "selections": [
      {
        "args": [
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "singleSelect_issueFieldSingleSelectEditviewFull_SingleSelectEditViewWithFieldOptionsFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ui_prefetchSingleSelectFieldOptionsQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "JiraOptionConnection",
                "kind": "LinkedField",
                "name": "fieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "value"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "optionId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isDisabled"
                          },
                          (v6/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v5/*: any*/),
                "filters": [
                  "searchBy",
                  "filterById"
                ],
                "handle": "connection",
                "key": "main_issueFieldSingleSelectEditviewFull__fieldOptions",
                "kind": "LinkedHandle",
                "name": "fieldOptions"
              }
            ],
            "type": "JiraSingleSelectField"
          },
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "7b75d4c24ffa334a2fa8ade5cd79af2b941370d14f5ea169012585b8a174753d",
    "metadata": {},
    "name": "ui_prefetchSingleSelectFieldOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d11d5054bd3348887bbf8d0ff0b23fd8";

export default node;
